import {
  Alternative,
  Content,
  ExerciseStudent,
  Question,
  QuestionStatus
} from "../../../../presentation/views/content/helpers";
import {ActionContext} from "vuex";
import {getContentProvider, getCurrentContent} from "./content_module";
import {ContentProvider} from "../../../../../domain/entities/content-provider/content-provider";
import {ExerciseState, getCurrentContentExercise} from "./exercise";
import questionnaire_control from "./questionnaire_control";
import {shuffle} from "../../../../presentation/components/mixins";

export class QuestionnaireState {
  currentQuestion: Question | null = null;
  alternatives: Alternative[] | null = null;
}

const state = new QuestionnaireState();

const mutations = {
  SET_CURRENT_QUESTION(state: QuestionnaireState, question: Question) {
    state.currentQuestion = question;
  },
  SET_CURRENT_QUESTION_STATUS(state: QuestionnaireState, questionStatus: QuestionStatus) {
    if (!state.currentQuestion) return;
    state.currentQuestion.status = questionStatus;
  },
  SET_ALTERNATIVES(state: QuestionnaireState, alternatives) {
    state.alternatives = alternatives;
  },
};

export const getCurrentQuestion = (ctx: ActionContext<any, any>) => {
  const currentQuestion: Question = ctx.rootGetters["content_module/questionnaire/currentQuestion"];
  if (!currentQuestion) throw new Error("[getCurrentQuestion] Error !currentQuestion");
  return currentQuestion;
}

type QuestionnaireActionContext = ActionContext<QuestionnaireState, ExerciseState>;
const actions = {
  async setCurrentQuestion(ctx: QuestionnaireActionContext, page: number) {
    try {
      const content: Content = getCurrentContent(ctx);
      const {status}: ExerciseStudent = getCurrentContentExercise(ctx);
      const questionnaireID: number = status.questionnaire.id;
      const provider: ContentProvider = getContentProvider(ctx);
      const question: Question = await provider.getQuestionByPage(content.id, questionnaireID, page);
      ctx.commit("SET_CURRENT_QUESTION", question);
      ctx.commit("SET_ALTERNATIVES", question.alternatives);
    } catch (e) {
      console.error("[setCurrentQuestion] Error ", e);
      throw e;
    }
  },

  async replyQuestionByPage(ctx: QuestionnaireActionContext, {
    page,
    alternativeID
  }: { page: number, alternativeID: number }) {
    try {
      const {status}: ExerciseStudent = getCurrentContentExercise(ctx);
      const questionnaireID: number = status.questionnaire.id;

      const provider: ContentProvider = getContentProvider(ctx);
      const content: Content = getCurrentContent(ctx);
      const questionStatus: QuestionStatus = await provider.replyQuestionByPage(content.id, questionnaireID, page, alternativeID);
      ctx.commit("SET_CURRENT_QUESTION_STATUS", questionStatus);
    } catch (e) {
      console.error("[setCurrentQuestion] Error ", e);
      throw e;
    }
  },

  async replyDescriptiveQuestionByPage(ctx: QuestionnaireActionContext, {
    page,
    answer
  }: { page: number, answer: string }) {
    try {
      const {status}: ExerciseStudent = getCurrentContentExercise(ctx);
      const questionnaireID: number = status.questionnaire.id;

      const provider: ContentProvider = getContentProvider(ctx);
      const content: Content = getCurrentContent(ctx);
      const questionStatus: QuestionStatus = await provider.replyDescriptiveQuestionByPage(content.id, questionnaireID, page, answer);
      ctx.commit("SET_CURRENT_QUESTION_STATUS", questionStatus);
    } catch (e) {
      console.error("[setCurrentQuestion] Error ", e);
      throw e;
    }
  },

  async shuffleAlternatives(ctx: QuestionnaireActionContext) {
    if(!ctx.state.alternatives) return;
    const alternatives = shuffle(ctx.state.alternatives);
    ctx.commit("SET_ALTERNATIVES", alternatives);
  }
};

const getters = {
  currentQuestion: (state: QuestionnaireState): Question | null => state.currentQuestion,
  alternatives: (state: QuestionnaireState): Alternative[] | null => state.alternatives,
};

const modules = {
  questionnaire_control
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules
}